"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Hitagi_Plugin_Stream {
    constructor(HitagiInstance) {
        this.last_ref = Math.floor(Math.random() * 10000000);
        this.OnWatchingMeEvents = [];
        this.Watchers = {};
        this.Streams = {};
        this.Refs = {};
        this.LIMIT_REACHED = "LIMIT_REACHED";
        this.STREAMER_LOGOUT = "STREAMER_LOGOUT";
        this.STREAM_STOP = "STREAM_STOP";
        this.STREAM_LOST = "STREAM_LOST";
        this.SnapshotInterval = 0;
        this.hitagi = HitagiInstance;
    }
    make_ref() {
        return "r" + (this.last_ref++);
    }
    start(LocalStream, Success, Error) {
        this.hitagi.log("Stream. Start streaming to server");
        if (typeof Error != "function")
            Error = function () { };
        if (typeof Success != "function")
            Success = function () { };
        this.local_stream = LocalStream;
        const device_id = LocalStream.getVideoTracks()[0].getSettings().deviceId;
        // TODO: this.hitagi.stream shouldn't depend oh this.hitagi.media
        // Needs to be reworked for `loose coupling` purposes
        if (!this.hitagi.media.local_stream)
            return;
        const muted = this.hitagi.media.local_stream.is_muted();
        const paused = this.hitagi.media.local_stream.is_paused();
        // Start streaming just a half second later.
        // It is enough to catch transition of track.readyState from 
        // 'live' to 'ended' when camera is not available to the browser
        const that = this;
        setTimeout(function () {
            that.hitagi.log("Stream. Camera is in '"
                + LocalStream.getVideoTracks()[0].readyState + "' state");
            if (LocalStream.getVideoTracks()[0].readyState == "ended") {
                that.hitagi.log("Stream. Camera is in 'ended' state, exiting");
                Error();
                return false;
            }
            let video_bitrate = 0;
            let audio_bitrate = 0;
            let reencode = true;
            try {
                video_bitrate = LocalStream.hitagi_constraints.video_bitrate;
                audio_bitrate = LocalStream.hitagi_constraints.audio_bitrate;
                reencode = LocalStream.hitagi_constraints.reencode;
            }
            catch (e) {
                that.hitagi.log("Cannot set constraints");
            }
            LocalStream.getVideoTracks()[0].onended = function (Evt) {
                that.stop();
            };
            const stream_peer = that.create_connection();
            that.stream_peer = stream_peer;
            if (typeof stream_peer.addTrack == "function") {
                LocalStream.getTracks().forEach(function (Track) {
                    //console.log(Track);
                    stream_peer.addTrack(Track, LocalStream);
                });
            }
            else {
                stream_peer.addStream(LocalStream);
            }
            stream_peer.oniceconnectionstatechange = function (event) {
                that.hitagi.log("StreamPeer.iceConnectionState: " +
                    this.iceConnectionState);
                if (this.iceConnectionState == "connected") {
                    Success();
                    if (that.hitagi.config.SnapshotIntervalSec != 0) {
                        clearInterval(that.SnapshotInterval);
                        //this.snapshot();
                        that.SnapshotInterval =
                            setInterval(that.snapshot.bind(that), that.hitagi.config.SnapshotIntervalSec * 1000);
                    }
                }
            };
            const snapshot = that.get_snapshot();
            const screenshot = paused ? that.get_screenshot() : false;
            const Args = {
                "video_bitrate": video_bitrate,
                "audio_bitrate": audio_bitrate,
                "reencode": reencode,
                "muted": muted,
                "paused": paused,
                "screenshot": screenshot,
                "snapshot": snapshot,
                "device_id": device_id
            };
            that.hitagi.action("stream", "start", Args, function () {
                if (!that.stream_peer)
                    return;
                that.stream_peer.createOffer(that.got_stream_description.bind(that), function (evt) { }).then(function (evt) {
                    that.got_stream_description(evt);
                });
                that.stream_peer.onicecandidate = that.got_stream_ice_candidate.bind(that);
            });
        }, 500);
    }
    stop() {
        if (!this.stream_peer)
            return;
        this.hitagi.action("stream", "stop");
        try {
            this.stream_peer.close();
        }
        catch (e) {
            this.hitagi.log("StreamPeer close failed");
        }
        clearInterval(this.SnapshotInterval);
    }
    callback__stream_started(Args) {
        // TODO: this.hitagi.stream shouldn't depend oh this.hitagi.media
        // Needs to be reworked for `loose coupling` purposes
    }
    callback__watcher_count(Args) {
        this.hitagi.fire_event("stream:watcher_count", Args);
    }
    callback__stream_server_sdp(Args) {
        if (!this.stream_peer)
            return;
        const Session = {
            sdp: Args.sdp,
            type: Args.type
        };
        this.stream_peer.setRemoteDescription(new RTCSessionDescription(Session));
    }
    callback__stream_server_ice(Args) {
        if (!this.stream_peer)
            return;
        const candidate = new RTCIceCandidate({ sdpMLineIndex: Args.stream_index, candidate: Args.ice });
        this.stream_peer.addIceCandidate(candidate);
    }
    got_stream_description(Description) {
        if (!Description)
            return;
        if (!this.stream_peer)
            return;
        this.hitagi.action("stream", "stream_sdp", { "sdp": Description.sdp, "type": Description.type });
        this.stream_peer.setLocalDescription(Description);
    }
    got_stream_ice_candidate(event) {
        if (!event.candidate)
            return;
        if (event.candidate.candidate = "")
            return;
        this.hitagi.log("Stream. Sending ICE to server");
        const IceCandidate = {
            "stream_index": event.candidate.sdpMLineIndex,
            "stream_label": event.candidate.sdpMid,
            "candidate": event.candidate.candidate
        };
        this.hitagi.action("stream", "stream_ice", IceCandidate);
    }
    got_view_description(Ufrag, Ref, Description) {
        this.hitagi.log("View. Sending SDP to server");
        const Args = {
            "ufrag": Ufrag,
            "sdp": Description.sdp,
            "type": Description.type,
            "ref": Ref
        };
        this.hitagi.action("stream", "view_sdp", Args);
        this.Refs[Ref].stream_peer
            .setLocalDescription(Description, function (Args) { }, function (Args) { });
    }
    got_view_ice_candidate(Ufrag, Ref, IceEvent) {
        if (!IceEvent.candidate)
            return;
        if (IceEvent.candidate.candidate = "")
            return;
        this.hitagi.log("View. Sending ICE to server");
        const Args = {
            "ufrag": Ufrag,
            "ref": Ref,
            "stream_index": IceEvent.candidate.sdpMLineIndex,
            "stream_label": IceEvent.candidate.sdpMid,
            "candidate": IceEvent.candidate.candidate
        };
        this.hitagi.action("stream", "view_ice", Args);
    }
    view(StreamId, Success, Stop, Restart) {
        this.hitagi.log("Stream. Start view stream from server " + StreamId);
        this.Streams["stream_" + StreamId] = {};
        this.Streams["stream_" + StreamId].Success = Success;
        this.Streams["stream_" + StreamId].Stop = function (Reason, Data) {
            Stop(Reason, Data);
        };
        this.Streams["stream_" + StreamId].Restart = Restart;
        //this.Streams["stream_" + StreamId].StreamPeer =
        //    Stream.create_connection();
        this.Streams["stream_" + StreamId].Status = "connecting";
        const Ref = this.make_ref();
        const ViewDesc = {
            ref: Ref,
            stream_id: StreamId,
            success: Success,
            stop: Stop,
            restart: Restart,
            stream_peer: this.create_connection(),
            status: "connecting"
        };
        this.Refs[Ref] = ViewDesc;
        const Packet = {
            "plugin": "stream",
            "action": "view",
            "args": {
                "stream_id": StreamId,
                "ref": Ref
            }
        };
        this.hitagi.send(Packet, function () { }, function (Result, Comment) {
            Stop(Comment);
        });
    }
    leave(StreamId, Data) {
        this.hitagi.log("Stream. Leaving stream of " + StreamId);
        this.hitagi.action("stream", "leave", { "stream_id": StreamId });
        this.Streams["stream_" + StreamId].Stop = function () { };
        //this.Streams["stream_" + StreamId].Stop("Leaving stream", Data);
    }
    stats(Success, Error) {
        this.hitagi.action("stream", "stats", {}, Success, Error);
    }
    callback__stream_ended(Args) {
        const Ufrag = Args.ufrag;
        try {
            this.Streams["stream_" + Ufrag].Stop("Stream ended");
        }
        catch (e) {
            return false;
        }
        return true;
    }
    callback__limit_reached(Args) {
        this.hitagi.fire_event("stream:limit_reached", Args);
    }
    callback__watching_me(Args) {
        // this.hitagi.room.Clients[Args.ufrag].watching = true;
        this.hitagi.fire_event("stream:watching_me", { "ufrag": Args.ufrag, "watching": true });
    }
    callback__not_watching_me(Args) {
        this.hitagi.fire_event("stream:watching_me", { "ufrag": Args.ufrag, "watching": false });
    }
    callback__view_server_sdp(Args) {
        const Ufrag = Args.ufrag;
        const Ref = Args.ref;
        const Session = {
            sdp: Args.sdp,
            type: Args.type
        };
        //var stream = this.Streams["stream_" + Ufrag];
        //var streamPeer = this.Streams["stream_" + Ufrag].StreamPeer;
        const stream = this.Refs[Ref];
        const streamPeer = this.Refs[Ref].stream_peer;
        stream.view_stream = null;
        const that = this;
        streamPeer.onicecandidate = function (event) {
            that.got_view_ice_candidate(Ufrag, Ref, event);
        };
        const onAddStreamEvent = streamPeer.ontrack !== undefined ? "ontrack" : "onaddstream";
        streamPeer[onAddStreamEvent] = function (e) {
            const view_stream = e.stream ? e.stream : e.streams[0];
            if (view_stream == stream.view_stream)
                return;
            if (stream.Status == "restarting") {
                stream.Restart(view_stream);
            }
            else {
                stream.success(view_stream);
            }
            stream.view_stream = view_stream;
        };
        streamPeer.setRemoteDescription(new RTCSessionDescription(Session))
            .then(function () {
            streamPeer.createAnswer()
                .then(function (Description) {
                that.got_view_description(Ufrag, Ref, Description);
            });
        })
            .catch(function (e) { that.hitagi.error(1001, e); });
    }
    callback__restart_stream(Args) {
        this.stop();
        if (this.local_stream) {
            this.start(this.local_stream);
        }
    }
    callback__restart_view(Args) {
        const Ref = Args["ref"];
        const Ufrag = Args["ufrag"];
        try {
            this.Refs[Ref].stream_peer.close();
            this.Refs[Ref].stream_peer = null;
        }
        catch (e) {
            this.hitagi.log("Failed to restart view " + Ref);
        }
        this.Refs[Ref].stream_peer = this.create_connection();
        this.Refs[Ref].status = "restarting";
        this.hitagi.action("stream", "view", { "ufrag": Ufrag, "ref": Ref });
    }
    callback__view_ended(Args) {
        const Ref = Args["ref"];
        const Reason = Args["reason"];
        try {
            this.Refs[Ref].stop(Reason);
            this.Refs[Ref].stop = null;
            this.Refs[Ref].stream_peer.close();
            this.Refs[Ref].stream_peer = null;
            delete this.Refs[Ref];
        }
        catch (e) {
            console.log(e);
        }
    }
    callback__record_stopped(Args) {
        const RecordId = Args.record_id;
        this.hitagi.fire_event("stream:record_stopped", Args);
        this.hitagi.fire_event("stream:record_stopped:" + RecordId, Args);
        this.hitagi.clear_event("stream:record_stopped:" + RecordId);
    }
    create_connection() {
        const PeerConnection = window.RTCPeerConnection;
        const PeerConfig = {
            "iceCandidatePoolSize": 8,
            "iceServers": [
                { "urls": ["stun:stun.l.google.com:19302"] }
            ]
        };
        return new PeerConnection(PeerConfig);
    }
    callback__view_server_ice(Args) {
        const Ref = Args.ref;
        const candidate = new RTCIceCandidate({ sdpMLineIndex: Args.stream_index, candidate: Args.ice });
        this.Refs[Ref].stream_peer.addIceCandidate(candidate);
    }
    talk() {
        this.hitagi.action("stream", "talk");
    }
    mute() {
        this.hitagi.action("stream", "mute");
    }
    pause() {
        this.hitagi.action("stream", "pause");
    }
    play() {
        this.hitagi.action("stream", "play");
    }
    on_watching_me(Func) {
        this.hitagi.on("watching_me", Func);
    }
    screenshot(Data, Success, Error) {
        this.hitagi.action("stream", "screenshot", { "data": Data }, Success, Error);
    }
    get_screenshot() {
        const Data = this.hitagi.media.getLastScreenshot();
        return Data;
    }
    get_snapshot() {
        const Data = this.hitagi.media.snapshot();
        return Data;
    }
    snapshot(Success, Error) {
        const Data = this.get_snapshot();
        if (Data != null) {
            this.hitagi.action("stream", "snapshot", { "data": Data }, Success, Error);
        }
    }
    record_start(Start, Stop, Error) {
        const hitagi = this.hitagi;
        hitagi.action("stream", "record_start", {}, function (Args) {
            const RecordId = Args.record_id;
            if (typeof Stop == "function") {
                hitagi.on("stream:record_stopped:" + RecordId, Stop);
            }
            if (typeof Start == "function")
                Start(Args);
        }, Error);
    }
    record_stop(Success, Error) {
        this.hitagi.action("stream", "record_stop", {}, Success, Error);
    }
    take_shot(Image, Success, Error) {
        if (Image != null) {
            this.hitagi.action("stream", "post_image", { "data": Image }, Success, Error);
        }
    }
    update_chat_list(List) {
        for (let i = 0; i < List.length; i++) {
            const Ufrag = List[i].ufrag;
            List[i].watching = (this.Watchers[Ufrag] !== undefined
                ? this.Watchers[Ufrag] : false);
        }
        return List;
    }
    callback__stream_update(Args) {
        this.hitagi.fire_event("stream:stream_update", Args);
    }
}
exports.default = Hitagi_Plugin_Stream;



//////////////////
// WEBPACK FOOTER
// ./node_modules/hitagi-js/build/hitagi_plugin_stream.js
// module id = ./node_modules/hitagi-js/build/hitagi_plugin_stream.js
// module chunks = main